import { render, staticRenderFns } from "./AdminHomeBusinessCard.vue?vue&type=template&id=d4c1fa88&scoped=true"
import script from "./AdminHomeBusinessCard.vue?vue&type=script&lang=js"
export * from "./AdminHomeBusinessCard.vue?vue&type=script&lang=js"
import style0 from "./AdminHomeBusinessCard.vue?vue&type=style&index=0&id=d4c1fa88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c1fa88",
  null
  
)

export default component.exports